import { z } from 'zod';

/**
 * Canonical actor classification shared across commands, queries, events,
 * and the audit log. Every action in the system is performed by an actor:
 *
 *  - `MEMBER` — a workspace member (the common case).
 *  - `ADMIN`  — an admin-app operator (platform staff).
 *  - `SYSTEM` — an automated process with no human actor (cron, the
 *    outbox-delivered auto-resume, migrations). Stamped with
 *    `SYSTEM_ACTOR_ID`.
 *
 * Identity only — workspace/organisation scope stays on the surrounding
 * command/query/event, never folded into the actor.
 */
export const ActorTypeSchema = z.enum(['MEMBER', 'ADMIN', 'SYSTEM']);

export type ActorType = z.infer<typeof ActorTypeSchema>;

export const ActorSchema = z.object({
  type: ActorTypeSchema,
  id: z.uuid(),
});

export type Actor = z.infer<typeof ActorSchema>;
